import React, { useState, useRef, useEffect } from 'react';
// import '../../../styles/eventcard.css';

const EventCard = ({ event, columnIndex,onCardAction }) => {
  const [showMenu, setShowMenu] = useState(false);
  const cardRef = useRef(null);

  const top = (event.startHour - 6) * 60;
  
  const height = (event.duration>=1?event.duration:1) * 60;

  const toggleMenu = (e) => {
    e.stopPropagation();
    setShowMenu(prev => !prev);
  };

  const handleAction = (action) => {
    alert(`${action} clicked for ${event.title}`);
    setShowMenu(false);
  };

  // Auto-close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (cardRef.current && !cardRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const onCallAction=(action,e)=>{
      onCardAction({action,event:e})
  }
  return (
    <div
      ref={cardRef}
      className="event-card"
      style={{
        gridColumn: `${columnIndex + 2}`,
        top: `${top}px`,
        height: `${height}px`,
        width:200
      }}
    >
      <div className="event-header">
        <strong>{event.title}</strong>
        <div className="menu-trigger" onClick={toggleMenu}>⋮</div>
      </div>
      <div style={{ fontSize: '11px' }}>{event.room}</div>
      <div style={{ fontSize: '10px' }}>{event.time}</div>

      {showMenu && (
        <div className="dropdown-menu">
          <div onClick={() => onCallAction("proceed",event)} className='selected'>Proceed to hearing</div>
          <div onClick={() => onCallAction("reschedule",event)} className='selected'>Re-Schedule</div>
          <div onClick={() => onCallAction("details",event)} className='selected'>Case Details</div>
          <div onClick={() => onCallAction("cancel",event)} className='selected'>Cancel</div>
        </div>
      )}
    </div>
  );
};

export default EventCard;
